import React from 'react';
import { Link } from 'react-router-dom';

import { Tooltip } from '@components';

import './User.scss';

const formatRelativeTime = (lastLoginTimestamp) => {
  if (!lastLoginTimestamp) {
    return null;
  }

  const lastLoginDate = new Date(lastLoginTimestamp);
  const now = new Date();
  const seconds = Math.round((now - lastLoginDate) / 1000);

  const fullTimestampString = `${lastLoginDate.toLocaleDateString()} ${lastLoginDate.toLocaleTimeString()}`;

  let relativeString;

  if (seconds < 10) {
    relativeString = 'Last login: just now';
  } else if (seconds < 60) {
    relativeString = `Last login: ${seconds} second${seconds === 1 ? '' : 's'} ago`;
  } else {
    const minutes = Math.round(seconds / 60);
    if (minutes < 60) {
      relativeString = `Last login: ${minutes} minute${minutes === 1 ? '' : 's'} ago`;
    } else {
      const hours = Math.round(minutes / 60);
      if (hours < 24) {
        relativeString = `Last login: ${hours} hour${hours === 1 ? '' : 's'} ago`;
      } else {
        const days = Math.round(hours / 24);
        if (days < 7) {
          relativeString = `Last login: ${days} day${days === 1 ? '' : 's'} ago`;
        } else if (days < 28) {
          const weeks = Math.round(days / 7);
          relativeString = `Last login: ${weeks} week${weeks === 1 ? '' : 's'} ago`;
        } else {
          // Calculate months and years
          const months = Math.round(days / 30.44); // Average days per month
          if (months < 12) {
            relativeString = `Last login: ${months} month${months === 1 ? '' : 's'} ago`;
          } else {
            const years = Math.round(months / 12);
            relativeString = `Last login: ${years} year${years === 1 ? '' : 's'} ago`;
          }
        }
      }
    }
  }

  return { fullTimestampString, relativeString };
};

const User = ({ user }) => {
  const lastLoginInfo = formatRelativeTime(user.last_login);

  return (
    <div className="sb-row-item">
      <div>
        <span className="sb-user-row-icon">
          {user.first_name[0].toUpperCase()}
        </span>
      </div>
      <div className="sb-row--user-name">
        <p>
          <b>
            <Link to={`/dashboard/users/${user.id}`}>
              {user.first_name} {user.last_name}
            </Link>
          </b>
        </p>
      </div>
      <div className="sb-row--user-email">
        <p>{user.email}</p>
      </div>
      {lastLoginInfo && (
        <div className="sb-row--user-last-login">
          <Tooltip tooltip={lastLoginInfo.fullTimestampString}>
            <p>{lastLoginInfo.relativeString}</p>
          </Tooltip>
        </div>
      )}
      <div className="sb-row--user-id">
        <p>ID: {user.id}</p>
      </div>
    </div>
  );
};

export default User;
